import React from "react";
import IconWeather from "./IconWeather";

export default function ForecastDay(props) {
  function maxTemperature() {
    return Math.round(props.forecast.temperature.maximum);
  }

  function minTemperature() {
    return Math.round(props.forecast.temperature.minimum);
  }

  function calcDay(data) {
    let day = new Date(data * 1000);
    let days = ["Sun", "Mon", "Tue", "Wen", "Thu", "Fri", "Sat"];
    return days[day.getDay()];
  }

  return (
    <div>
      <div className="kard">
        <div className="mb-2">{calcDay(props.forecast.time)}</div>
        <IconWeather icon={props.forecast.condition.icon} size={44} />
        <div>
          <span className="max-temp">{maxTemperature()}°</span>{" "}
          <span className="min-temp">{minTemperature()}°</span>
        </div>
      </div>
    </div>
  );
}
